module.exports = __webpack_public_path__ + "static/img/dockercon-2018-banner.dacc2ed.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/dockercon-2018-banner.svg
// module id = K7F0
// module chunks = 1